<template>
  <button class="edit-icon noborder bg-transparent pointer"
          @click="$emit('click')">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 21.0001H20M5.666 13.1871C5.23962 13.6144 5.00011 14.1934 5 14.7971V18.0001H8.223C8.827 18.0001 9.406 17.7601 9.833 17.3321L19.333 7.82709C19.7592 7.39969 19.9986 6.82071 19.9986 6.21709C19.9986 5.61348 19.7592 5.03449 19.333 4.60709L18.395 3.66709C18.1835 3.45544 17.9323 3.28757 17.6558 3.17306C17.3794 3.05855 17.083 2.99966 16.7838 2.99976C16.4846 2.99985 16.1883 3.05892 15.9119 3.1736C15.6355 3.28828 15.3844 3.45631 15.173 3.66809L5.666 13.1871Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</template>

<script>
  export default {
    name: 'EditIcon',
    cy: String
  }
</script>

<style lang="less">
  .edit-icon {
    @media only screen and (min-width: 0) {

    }
  }
</style>
